import { ICollapsibleMenuActionItemParams } from '@components/common/CollapsibleActionsMenu/CollapsibleActionsMenu';

import { IConsistencyCheckRanFilter } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { EChangeMonitoringActions } from './constants';

export const getAssignConsistencyCheckOptions: (
	isIdsLength?: boolean,
	isFilterEmpty?: boolean
) => ICollapsibleMenuActionItemParams<string>[] = (
	isIdsLength?: boolean,
	isFilterEmpty?: boolean,
) => [
	{
		name: 'enableMonitoring',
		label: 'Enable',
		items: [
			{
				id: EChangeMonitoringActions.enableSelected,
				text: 'Selected on current page',
				disabled: !isIdsLength,
			},
			{
				id: EChangeMonitoringActions.enableCurrentPage,
				text: 'Current page',
				disabled: false,
			},
			{
				id: EChangeMonitoringActions.enableAll,
				text: 'All',
				disabled: false,
			},
			{
				id: EChangeMonitoringActions.enableAllFiltered,
				text: 'All filtered',
				disabled: isFilterEmpty,
			},
		],
	},
	{
		name: 'disableMonitoring',
		label: 'Disable',
		items: [
			{
				id: EChangeMonitoringActions.disableSelected,
				text: 'Selected on current page',
				disabled: !isIdsLength,
			},
			{
				id: EChangeMonitoringActions.disableCurrentPage,
				text: 'Current page',
				disabled: false,
			},
			{
				id: EChangeMonitoringActions.disableAll,
				text: 'All',
				disabled: false,
			},
			{
				id: EChangeMonitoringActions.disableAllFiltered,
				text: 'All filtered',
				disabled: isFilterEmpty,
			},
		],
	},
];

export const getMonitoringParams = ({
	actionId,
	currentPageIds,
	selectedIds,
	filter,
	setIsDisableMode,
}:{
	actionId: string;
	currentPageIds?: string[];
	selectedIds?: string[];
	filter?: IConsistencyCheckRanFilter;
	setIsDisableMode: (isDisableMode: boolean) => void;
}) => {
		switch (actionId) {
			case EChangeMonitoringActions.disableAll:
			case EChangeMonitoringActions.enableAll:
				setIsDisableMode(actionId === EChangeMonitoringActions.disableAll);

				return {
					isAll: true,
					ids: [],
					filter: undefined,
				};
			case EChangeMonitoringActions.disableCurrentPage:
			case EChangeMonitoringActions.enableCurrentPage:
				setIsDisableMode(actionId === EChangeMonitoringActions.disableCurrentPage);

				return {
					isAll: false,
					ids: currentPageIds,
					filter: undefined,
				};
			case EChangeMonitoringActions.disableSelected:
			case EChangeMonitoringActions.enableSelected:
				setIsDisableMode(actionId === EChangeMonitoringActions.disableSelected);

				return {
					isAll: false,
					ids: selectedIds,
					filter: undefined,
				};
			case EChangeMonitoringActions.disableAllFiltered:
			case EChangeMonitoringActions.enableAllFiltered:
				setIsDisableMode(actionId === EChangeMonitoringActions.disableAllFiltered);

				return {
					isAll: true,
					ids: [],
					filter,
				};
			default:
				return;
		}
	};
